import { isFrameRateId, DEFAULT_FRAME_RATE_ID, type FrameRateId } from '../frame/frameRates';

export type ThemeId = 'dark' | 'color' | 'light';
const THEMES: readonly ThemeId[] = ['dark', 'color', 'light'];

export interface Preferences {
  theme: ThemeId;
  rateId: FrameRateId;
  ntpSyncEnabled: boolean;
}

export const DEFAULTS: Preferences = {
  theme: 'color',
  rateId: DEFAULT_FRAME_RATE_ID,
  ntpSyncEnabled: false,
};

const STORAGE_KEY = 'delayscope.preferences';

function isTheme(value: unknown): value is ThemeId {
  return typeof value === 'string' && (THEMES as readonly string[]).includes(value);
}

export function loadPreferences(): Preferences {
  let raw: string | null;
  try {
    raw = localStorage.getItem(STORAGE_KEY);
  } catch {
    return { ...DEFAULTS };
  }
  if (!raw) return { ...DEFAULTS };
  let parsed: unknown;
  try {
    parsed = JSON.parse(raw);
  } catch {
    return { ...DEFAULTS };
  }
  if (!parsed || typeof parsed !== 'object') return { ...DEFAULTS };
  const p = parsed as Record<string, unknown>;
  return {
    theme: isTheme(p.theme) ? p.theme : DEFAULTS.theme,
    rateId: isFrameRateId(p.rateId) ? p.rateId : DEFAULTS.rateId,
    ntpSyncEnabled: typeof p.ntpSyncEnabled === 'boolean' ? p.ntpSyncEnabled : DEFAULTS.ntpSyncEnabled,
  };
}

export function savePreferences(prefs: Preferences): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(prefs));
  } catch {
    /* swallow quota/private-mode errors; in-memory state still works */
  }
}
